import React, {Fragment} from 'react'
import styles from './ShareModal.scss'
import {errorMessage} from 'lib/styleguide/base.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {CircleSpinner} from 'common/spinners/CircleSpinner'
import {Icon} from 'common/Icon'
import {apiv3} from 'lib/apiv3'
import QRCode from 'qrcode.react'

export class ShareModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      appCode: null,
      savePending: false,
      customCode: null
    }
  }

  componentDidMount () {
    apiv3.experiences.appCode(this.props.experience.id)
      .then(({appCode}) => { this.setState({appCode}) })
  }

  onCodeChange = (e) => {
    const customCode = e.target.value.toUpperCase()
    // only allow letters, numbers, and hyphens... but don't allow more than one hyphen in a row (TOUR-123 good, TOUR---1 bad)
    if (/^[a-z0-9-]*$/i.test(customCode) && !/[-]{2}/.test(customCode)) {
      this.setState({customCode, codeInUse: false})
    }
  }

  generateNewCode = () => {
    if (this.state.savePending) return
    this.setState({savePending: true})
    apiv3.experiences.generateAppCode(this.props.experience.id)
      .then(({appCode}) => { this.setState({appCode, customCode: null, savePending: false, codeInUse: false}) })
  }

  saveCode = (e) => {
    e.preventDefault()
    if (this.saveDisabled()) {
      return
    }
    this.setState({savePending: true})
    apiv3.experiences.updateCode(this.props.experience.id, {code: this.state.customCode})
      .then(({appCode}) => { this.setState({appCode, customCode: null, savePending: false}) })
      .catch(() => { this.setState({savePending: false, codeInUse: true}) })
  }

  saveDisabled () {
    return this.state.savePending || !this.state.customCode
  }

  render () {
    const {onRequestClose, experience} = this.props
    const {appCode, customCode, savePending, codeInUse} = this.state

    if (!appCode) return <div />

    return (
      <ModalOverlay
        maxWidth={600}
        onRequestClose={onRequestClose}
        title='Share Shortcut'>
        <p>
          Create your own code, or use the shortcut code below to invite guests to the Experience Guide.
        </p>
        <form onSubmit={this.saveCode}>
          <div style={{display: 'flex'}}>
            <div style={{flexGrow: 1}}>
              <input type='text' value={customCode === null ? appCode.code : customCode} onChange={this.onCodeChange} />
            </div>
            <div style={{width: '150px', marginLeft: '10px'}}>
              <CTA button type='submit' disabled={this.saveDisabled()} margins={false}>
                {savePending && <Fragment>
                  <CircleSpinner size={14} />
                  <span style={{ marginLeft: '10px' }}>Saving...</span>
                </Fragment>}
                {!savePending && customCode !== null && <span>Save Code</span>}
                {!savePending && customCode === null && <span>Saved.</span>}
              </CTA>
            </div>
          </div>
          {codeInUse && <div className={errorMessage}>
            <strong>{customCode}</strong> is already in use. Please choose a different code.
          </div>}
        </form>
        <div style={{textAlign: 'center', marginTop: '10px', marginBottom: '30px'}}>
          <a href='#' onClick={this.generateNewCode}>Generate new code</a>
        </div>
        <hr />
        <div className={styles.qrCode}>
          <QRCode value={`rwgps://app/code/${appCode.code.toUpperCase()}`} size={180} level='M' />
        </div>
        <div style={{textAlign: 'center', marginTop: '30px'}}>
          <CTA secondary inline margins={false}
            onClick={() => { window.location = `/experiences/${experience.id}/qr_code.png` }}>
            <Icon i='md-download' /> Download PNG
          </CTA>
          <CTA link inline margins={false} className={styles.secondaryDownload}
            onClick={() => { window.location = `/experiences/${experience.id}/qr_code.svg` }}>
            <Icon i='md-download' /> SVG
          </CTA>
        </div>
      </ModalOverlay>
    )
  }
}
